import { createContext, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";


const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const {isLogged, loading, getToken, logout} = useAuth();

    return (
        <AuthContext.Provider value={{ isLogged, loading, getToken, logout}}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;